<template>
  <div>
    <v-icon
      v-if="showOne && item.status === status || !showOne"
      small
      class="mx-1"
      v-for="item in statuses"
      :key="item.status"
      :color="!item.statuses.includes(status) ? 'grey' : item.color"
      v-html="item.icon"
      @click="$emit('set-force-status', item.statuses[0])"
    ></v-icon>
  </div>
</template>

<script>
export default {
  name: "DiagnosticStatusIcons",
  props: {
    status: null,
    showOne: false
  },
  data() {
    return {
      statuses: [
        { color: "green", statuses: ["good"], icon: "fa-thumbs-up" },
        { color: "black", statuses: ["bad"], icon: "fa-thumbs-down" },
        { color: "warning", statuses: ["alarm"], icon: "fa-exclamation-triangle" },
        { color: "red", statuses: ["ban", "unit_does_not_exist"], icon: "fa-ban" },
        { color: "blue", statuses: ["question"], icon: "fa-question" },
      ],
    };
  },
};
</script>

<style scoped></style>
